import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueMq from "vue-mq";
import "vuetify/src/stylus/app.styl";
import fr from "vuetify/es5/locale/fr";
import VuetifyGoogleAutocomplete from "../plugins/vga/index";
import { VTextField } from "vuetify/lib";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#95cbbf",
    secondary: "#b0bec5",
    accent: "#FF7C5D",
    error: "#b71c1c"
  },
  components: {
    VTextField
  },
  lang: {
    locales: { fr },
    current: "fr"
  }
});

Vue.use(VuetifyGoogleAutocomplete, {});

Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: "sm" // customize this for SSR
});
